(function () {
    "use strict";

    angular.module('app').factory('userFunctions', UserFunctionsFactory);

    UserFunctionsFactory.$inject = ['user'];
    function UserFunctionsFactory(user) {
        return {
            'currentUserHasRole': (roleName) => userHasAnyRole(user, [roleName]),
            userHasAnyRole: userHasAnyRole,
            currentUserReferenceNbr: () => getUserReferenceNbr(user),
            userWorksForPartner: (partnerName) => getUserWorksForPartner(user, partnerName)
        };

        function userHasAnyRole(user, roles) {
            // Empty user or user without roles
            if (!user || !user.UserHasRoles) {
                return false;
            }

            // No roles provided
            if (!roles) {
                return false;
            }

            for (const roleName of roles) {
                const role = _.find(user.UserHasRoles, { RoleName: roleName });

                if (role) {
                    return true;
                }
            }

            return false;
        }

        function getUserReferenceNbr(user) {
            // Empty user or user without roles
            if (!user || !user.UserHasRoles) {
                return "";
            }

            return user.ReferenceNbr;
        }

        function getUserWorksForPartner(user, partnerName) {
            // Empty user or user without roles
            if (!user || !user.WorksForPartner) {
                return "";
            }

            return user.WorksForPartner == partnerName;
        }
    }
})();
